import { render, staticRenderFns } from "./restriktionen-legende.vue?vue&type=template&id=24ce422a&scoped=true"
import script from "./restriktionen-legende.vue?vue&type=script&lang=js"
export * from "./restriktionen-legende.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-legende.vue?vue&type=style&index=0&id=24ce422a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce422a",
  null
  
)

export default component.exports